import { vodPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Lens / VMS - Cloud Encoding (VOD) console.
  { scope: 'External.SwiftCoder', category: 'streaming', route: vodPaths.service },
] as const;
